import React ,{Component} from 'react'
class Dashboard extends Component{
    constructor(props){
        super(props)
    }
render(){
    return( <div><h2 className="heading">Not Available</h2></div> )
}
}
export default Dashboard

